import React from "react";
import { ArrowRight } from "lucide-react";
import "./price.css";
import scrollTopPage from "../../global";
import imgLive from "../images/live.jpg";
import imgOnline from "../images/online-trening1.jpeg";
import imgDiet from "../images/plan-ishrane.jpeg";
import "../../global.css";

const services = [
  {
    num: "01",
    title: "UŽIVO TRENING",
    desc: "Treniraj direktno sa Mihailom u teretani. Svaki trening je prilagođen tvom nivou i ciljevima, uz stručno vođenje i motivaciju od prvog časa.",
    href: "/trening-uzivo/",
    img: imgLive,
    mod: "service-card--light",
  },
  {
    num: "02",
    title: "ONLINE TRENING",
    desc: "Plan i program treninga prilagođen tebi, praćenje napretka i konstantna podrška — sve online, kad god ti odgovara.",
    href: "/online-trening/",
    img: imgOnline,
    mod: "service-card--dark",
  },
  {
    num: "03",
    title: "PLAN ISHRANE",
    desc: "Personalizovan plan ishrane sa tačnim kalorijama, savetima o suplementima i konsultacijama sa trenerom.",
    href: "/plan-ishrane/",
    img: imgDiet,
    mod: "service-card--accent",
  },
];

export default function Price() {
  return (
    <section className="services-section" id="price">
      <div className="services-inner">
        <div className="services-header">
          <div className="services-header-left">
            <div className="services-eyebrow">Šta nudim</div>
            <h2 className="services-title">MOJE USLUGE</h2>
          </div>
          <a href="/kontakt/" onClick={scrollTopPage} className="services-all-link">
            Pogledaj sve <ArrowRight size={15} strokeWidth={2.2} />
          </a>
        </div>

        <div className="services-grid">
          {services.map((s) => (
            <div key={s.num} className={`service-card ${s.mod}`}>
              <div className="service-card-img">
                <img src={s.img} alt={s.title} />
              </div>
              <div className="service-card-body">
                <span className="service-card-num">{s.num}</span>
                <h3 className="service-card-title">{s.title}</h3>
                <p className="service-card-desc">{s.desc}</p>
                <a href={s.href} onClick={scrollTopPage} className="service-card-btn">
                  <ArrowRight size={20} strokeWidth={2.2} />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
